import { ApiKey, BaseUrl } from '../global'
import axios from 'axios'

export const cxmpLogin = async (data, source) => {
    try {
        //api/Login
        const rs = await axios.post(BaseUrl + 'api/CXMP/Login', data);
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e };
    }
}

export const createTicketCXMP = async (data, token, source) => {
    try {
        //api/Ticket_Management/Create_Ticket_MNP
        const rs = await axios.post(BaseUrl + 'api/CXMP/CreateTicket', data, {
            cancelToken: source ? source.token : null,
            headers: {
                'Authorization': token
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e };
    }
}


export const getCXMPTicketDetailById = async (cn, token, source) => {
    try {
        // api/Ticket_Management/Get_Ticket_Detail_ByCN?cn=cn?
        const rs = await axios.get(BaseUrl + 'api/CXMP/GetTicketDetailByCN?cn=' + cn, {
            cancelToken: source ? source.token : null,
            headers: {
                'Authorization': token
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e };
    }
}



export const getRequestNatureCXMP = async (token, source) => {
    try {
        // api/Request_Nature/Get_Request_Nature
        const rs = await axios.get(BaseUrl + 'api/CXMP/RequestNature', {
            cancelToken: source ? source.token : null,
            headers: {
                'Authorization': token
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e };
    }
}

export const getRequestTypeCXMP = async (id, token, source) => {
    try {
        // api/Request_Type/Get_Request_Type?Request_Nature=id
        const rs = await axios.get(BaseUrl + 'api/CXMP/RequestType?Request_Nature=' + id, {
            cancelToken: source ? source.token : null,
            headers: {
                'Authorization': token
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e };
    }
}


export const getInquireTypeCXMP = async (token, source) => {
    try {
        // api/Inquire/Get_Inquire
        const rs = await axios.get(BaseUrl + 'api/CXMP/GetInquire', {
            cancelToken: source ? source.token : null,
            headers: {
                'Authorization': token
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e };
    }
}

export const getAssignZoneCXMP = async (id, token, source) => {
    try {
        // api/Zone/Get_Zone?Region=id
        const rs = await axios.get(BaseUrl + 'api/CXMP/GetZone?Region=' + id, {
            cancelToken: source ? source.token : null,
            headers: {
                'Authorization': token
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e };
    }
}


export const getAssignBranchCXMP = async (id, token, source) => {
    try {
        // api/Branch/Get_Branch?Zone=id
        const rs = await axios.get(BaseUrl + 'api/CXMP/GetBranch?Zone=' + id, {
            cancelToken: source ? source.token : null,
            headers: {
                'Authorization': token
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e };
    }
}

export const getCnDetails = async (cn, source) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/Reports/CnDetails?cn=' + cn, {
            cancelToken: source ? source.token : null,
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e };
    }
}

export const getRequestTypesAndDetails = async (source) => {
    try {
        const rs = await axios.get(BaseUrl + 'api/Complaint/GetRequestTypesAndDetails', {
            cancelToken: source ? source.token : null,
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e };
    }
}

export const getTicketInfo = async (cn, source) => {
    try {
        const rs = await axios.get(BaseUrl + 'api/Complaint/GetTicketInfo?cn=' + cn, {
            cancelToken: source ? source.token : null,
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e };
    }
}

export const updateTicket = async (data, source) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/Complaint/UpdateTicket', data, {
            cancelToken: source ? source.token : null,
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e };
    }
}

export const getTickets = async (data, source) => {
    try {
        const rs = await axios.post(BaseUrl + 'api/Complaint/GetTickets', data, {
            cancelToken: source ? source.token : null,
            headers: {
                key: ApiKey,
            }
        });
        return rs.data;
    } catch (e) {
        console.log(e);
        return { ok: false, msg: e };
    }
}